<template>
  <div class="treatment-page">
    <div class="hero-section">
      <div class="container">
        <h1>Wortelkanaalbehandeling Sint-Michielsgestel</h1>
        <p class="lead">Professionele wortelkanaalbehandelingen bij Tandzorg Gestel. Pijnloze behandeling met moderne technieken voor het behoud van uw eigen tanden.</p>
      </div>
    </div>

    <div class="content-section">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <h2>Wat is een wortelkanaalbehandeling?</h2>
            <p>Een wortelkanaalbehandeling, ook wel endodontische behandeling genoemd, is een tandheelkundige procedure waarbij ontstoken of geïnfecteerd tandweefsel uit de wortelkanalen van een tand wordt verwijderd. Deze behandeling is vaak nodig wanneer de tandzenuw (pulpa) beschadigd is door diepe cariës, trauma, of herhaalde tandheelkundige procedures.</p>

            <p>Bij Tandzorg Gestel in Sint-Michielsgestel voeren onze ervaren tandartsen wortelkanaalbehandelingen uit met de nieuwste technieken en apparatuur. Ons doel is om uw natuurlijke tand te behouden en u van pijn te verlossen.</p>

            <h2>Wanneer is een wortelkanaalbehandeling nodig?</h2>
            <p>Een wortelkanaalbehandeling kan nodig zijn bij verschillende symptomen:</p>
            <ul>
              <li><strong>Ernstige tandpijn</strong> bij bijten of druk uitoefenen</li>
              <li><strong>Langdurige gevoeligheid</strong> voor warme of koude temperaturen</li>
              <li><strong>Verkleuring</strong> van de tand</li>
              <li><strong>Zwelling en pijn</strong> in het nabijgelegen tandvlees</li>
              <li><strong>Terugkerende fistels (puistjes)</strong> op het tandvlees</li>
              <li><strong>Spontane pijn</strong> die u 's nachts wakker houdt</li>
            </ul>

            <h2>Het behandelproces bij Tandzorg Gestel</h2>
            <p>Onze wortelkanaalbehandelingen worden uitgevoerd in een comfortabele, stressvrije omgeving in Sint-Michielsgestel:</p>
            
            <h3>Stap 1: Diagnose en Planning</h3>
            <p>We beginnen met een grondige röntgenonderzoek om de situatie van uw tand en wortelkanalen te beoordelen. Onze tandarts bespreekt de behandelplan uitgebreid met u.</p>

            <h3>Stap 2: Verdoving</h3>
            <p>De behandeling wordt altijd onder lokale verdoving uitgevoerd, zodat u geen pijn voelt tijdens de procedure. Bij angst voor de tandarts kunnen we extra maatregelen nemen voor uw comfort.</p>

            <h3>Stap 3: Toegang en Reiniging</h3>
            <p>We maken een kleine opening in de kroon van de tand om toegang te krijgen tot de geïnfecteerde pulpa. Vervolgens worden de wortelkanalen zorgvuldig gereinigd en gedesinfecteerd.</p>

            <h3>Stap 4: Vulling en Afsluiting</h3>
            <p>Na reiniging worden de wortelkanalen gevuld met een biocompatibel materiaal en afgesloten. De toegangsopening wordt hersteld met een vulling of kroon.</p>

            <h2>Voordelen van wortelkanaalbehandeling</h2>
            <ul>
              <li><strong>Behoud van uw natuurlijke tand</strong> - geen extractie nodig</li>
              <li><strong>Pijnverlichting</strong> - eliminatie van tandpijn en infectie</li>
              <li><strong>Kosteneffectief</strong> - voorkomt duurdere vervangingsopties</li>
              <li><strong>Normale kauwfunctie</strong> - behoud van eetcomfort</li>
              <li><strong>Esthetisch resultaat</strong> - geen zichtbare gaten in uw gebit</li>
            </ul>

            <h2>Nazorg na wortelkanaalbehandeling</h2>
            <p>Na uw wortelkanaalbehandeling bij Tandzorg Gestel geven we u uitgebreide nazorginstructies. De meeste patiënten kunnen binnen enkele dagen terugkeren naar normale activiteiten. We plannen vervolgafspraken om de genezing te controleren en eventueel een definitieve kroon te plaatsen.</p>

            <h2>Kosten en verzekering</h2>
            <p>Wortelkanaalbehandelingen vallen meestal onder uw basisverzekering. Ons team helpt u graag bij het afhandelen van uw verzekeringsclaim en geeft vooraf inzicht in de verwachte kosten.</p>

            <h2>Waarom kiezen voor Tandzorg Gestel?</h2>
            <ul>
              <li><strong>Ervaren specialisten</strong> in Sint-Michielsgestel</li>
              <li><strong>Moderne apparatuur</strong> en technieken</li>
              <li><strong>Persoonlijke aandacht</strong> en uitgebreide nazorg</li>
              <li><strong>Flexibele planning</strong> ook voor spoedgevallen</li>
              <li><strong>Transparante communicatie</strong> over behandeling en kosten</li>
            </ul>
          </div>

          <div class="col-md-4">
            <div class="appointment-card">
              <h3>Plan uw afspraak</h3>
              <p>Heeft u pijn aan uw tand of vermoedt u dat u een wortelkanaalbehandeling nodig heeft?</p>
              <router-link to="/contact" class="link-btn">Contact opnemen</router-link>
              <router-link to="/afspraak-maken" class="link-btn">Afspraak maken</router-link>
              
              <div class="contact-info">
                <h4>Spoedgevallen</h4>
                <p>📞 <a href="tel:+31735515644" class="contact-link">073-5515644</a></p>
                <p>✉️ <a href="mailto:info@tandzorggestel.nl" class="contact-link">info@tandzorggestel.nl</a></p>
              </div>
            </div>

            <div class="related-treatments">
              <h4>Gerelateerde behandelingen</h4>
              <ul>
                <li><router-link to="/cosmetische-tandheelkunde">Cosmetische tandheelkunde</router-link></li>
                <li><router-link to="/mondhygiene">Professionele reiniging</router-link></li>
                <li><router-link to="/vullingen">Vullingen en reparaties</router-link></li>
                <li><router-link to="/kronen-bruggen">Kronen en bruggen</router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Wortelkanaalbehandeling',
  mounted() {
    // SEO optimization
    document.title = "Wortelkanaalbehandeling Sint-Michielsgestel | Tandzorg Gestel | Pijnloze Behandeling";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professionele wortelkanaalbehandeling bij Tandzorg Gestel in Sint-Michielsgestel. Pijnloze behandeling met moderne technieken. Spoed mogelijk. Plan uw afspraak.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'wortelkanaalbehandeling, endodontie, tandpijn, tandarts Sint-Michielsgestel, Tandzorg Gestel, wortelkanaal, kiespijn');
    }
    
    // Schema.org structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "MedicalProcedure",
      "name": "Wortelkanaalbehandeling",
      "description": "Professionele wortelkanaalbehandeling bij Tandzorg Gestel in Sint-Michielsgestel",
      "provider": {
        "@type": "Dentist",
        "name": "Tandzorg Gestel",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Schijndelseweg 13A",
          "addressLocality": "Sint-Michielsgestel",
          "postalCode": "5271 BK",
          "addressCountry": "NL"
        },
        "telephone": "+31735515644"
      },
      "medicalSpecialty": "Endodontics"
    });
    document.head.appendChild(script);
  }
}
</script>

<style scoped>
.treatment-page {
  padding-top: 88px;
}

.hero-section {
  background: linear-gradient(135deg, var(--blue), #0099a3);
  color: white;
  padding: 4rem 0;
  text-align: center;
}

.hero-section h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: bold;
}

.lead {
  font-size: 1.3rem;
  max-width: 600px;
  margin: 0 auto;
}

.content-section {
  padding: 4rem 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.row {
  display: flex;
  gap: 3rem;
}

.col-md-8 {
  flex: 2;
}

.col-md-4 {
  flex: 1;
}

.content-section h2 {
  color: var(--blue);
  font-size: 2.2rem;
  margin: 2rem 0 1rem 0;
}

.content-section h3 {
  color: var(--black);
  font-size: 1.5rem;
  margin: 1.5rem 0 0.5rem 0;
}

.content-section p {
  line-height: 1.8;
  margin-bottom: 1rem;
  color: var(--light-color);
  font-size: 1.6rem;
}

.content-section ul {
  margin: 1rem 0;
  padding-left: 2rem;
}

.content-section li {
  margin-bottom: 0.5rem;
  color: var(--light-color);
  font-size: 1.6rem;
  line-height: 1.6;
}

.appointment-card {
  background: var(--light-bg);
  padding: 2rem;
  border-radius: 10px;
  margin-bottom: 2rem;
  box-shadow: var(--box-shadow);
}

.appointment-card h3 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.appointment-card .link-btn {
  display: block;
  margin-bottom: 1rem;
  text-align: center;
}

.contact-info {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #ddd;
}

.contact-info h4 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.related-treatments {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: var(--box-shadow);
}

.related-treatments h4 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.related-treatments ul {
  list-style: none;
  padding: 0;
}

.related-treatments li {
  margin-bottom: 0.5rem;
}

.related-treatments a {
  color: var(--light-color);
  text-decoration: none;
  font-size: 1.4rem;
}

.related-treatments a:hover {
  color: var(--blue);
}

@media (max-width: 768px) {
  .row {
    flex-direction: column;
    gap: 2rem;
  }
  
  .hero-section h1 {
    font-size: 2.5rem;
  }
  
  .lead {
    font-size: 1.1rem;
  }
  
  .content-section {
    padding: 2rem 0;
  }
}
</style>
